// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"377":"chat","545":"language","822":"disclaimer"}[chunkId] + "." + {"377":"0ef5083b","545":"06ac5223","822":"9013ff66"}[chunkId] + ".css";
};